<template lang="pug">
  .comment__list
    .comment__user
      .comment__user-col
        Avatar( :img="value.commentatorAvatar" circle size="s")
        .comment__user-info
          .comment__user-info__name
            | {{value.commentatorName }}
          .comment__user-info__type
            | {{value.isValidator ? 'Проверяющий' : value.commentatorEmail}}
      .comment__user-end
        .comment__user-date
          | {{ value.createdAt }}
    .comment__list-text(v-html="answerHTML")
    .comment__list-file
      File( v-for="(file, i) in value.commentatorFiles"
        :key="file.name +'_'+i"
        :file="file"
        :canDelete="false"
      )

</template>
<script>
import { mapState } from 'vuex';
import File from '@/components/File/File';
import textToHtmlWithLinks from '@/functions/textToHTMLWithLikns';

export default {
  components: {
    File
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    ...mapState('auth', {
      $permissions: s => s.data.user.permissions.taskAnswerCheckAdmin,
      $otherPermissions: s => s.data.user.permissions,
      isAdmin: s => s.data.user.permissions.isAdmin
    }),
    answerHTML() {
      return textToHtmlWithLinks(this.value.comment);
    }
  }
};
</script>
